define('TescoMobile_Checkout/js/form/element/password',['Magento_Ui/js/form/element/abstract', 'jquery', 'mage/translate', 'TescoMobile_Checkout/js/action/validate-password'], function (Component, $, $t, validatePasswordFunc) {
  'use strict';

  return Component.extend({
    defaults: {
      template: 'TescoMobile_Checkout/form/element/password',
      confirmPassword: '',
      customerEmailSelector: '#customer-email',
      passwordSelector: '#customer-password',
      confirmPasswordSelector: '#customer-confirm-password',
      togglePasswordSelector: '.toggle-customer-password',
      confirmError: false,
      confirmMatch: false,
      requiredError: false,
      passwordConfirmRequiredError: false,
      invalidOnSubmit: false,
      listens: {
        value: 'getValue',
        validateConfirmPassword: 'validateConfirm',
        validatePassword: 'validationHints validateConfirm',
        '${ $.provider }:${ $.customScope ? $.customScope + "." : ""}data.validate': 'validateSubmit'
      },
      validationMessagesCollection: [],
      validationState: [],
      isCheckout: true
    },
    getValue: function () {
      this.source.set('about.account.password', $(this.passwordSelector).val());
      return $(this.passwordSelector).val();
    },
    initObservable: function () {
      return this._super().observe(['confirmPassword', 'confirmPasswordFocused', 'confirmError', 'validatePassword', 'validateConfirmPassword', 'requiredError', 'passwordConfirmRequiredError', 'confirmMatch', 'passwordHints', 'invalidOnSubmit']);
    },
    _updatePasswordHintsValues: function (config) {
      let hints = [],
        _self = this;
      $.each(config, function (key, value) {
        if (key === 'maximum_password_length' || key === 'minimum_uppercase' || key === 'minimum_digits') {
          return;
        }
        let hint = {
          key: key,
          message: _self.getValidateMassageByKey(key),
          valid: false
        };
        hints.push(hint);
      });
      return hints;
    },
    getValidateMassageByKey: function (key) {
      if (this.validationMessagesCollection[key] !== 'undefined') {
        return this.validationMessagesCollection[key];
      }
      return '';
    },
    collectValidationMessage: function (config) {
      let _self = this;
      $.each(config, function (key, value) {
        let validateMassage = '';
        if (key === 'minimum_password_length' || key === 'maximum_password_length') {
          validateMassage = $.mage.__('be between %1 and %2 characters long').replace('%1', config.minimum_password_length).replace('%2', config.maximum_password_length);
        }
        if (key === 'minimum_lowercase' || key === 'minimum_uppercase' || key === 'minimum_digits') {
          validateMassage = $.mage.__('contains at least %1, %2 and %3.').replace('%1', config.minimum_digits > 1 ? config.minimum_digits + ' numerics' : 'one numeric').replace('%2', config.minimum_uppercase > 1 ? config.minimum_uppercase + ' uppercase characters' : 'one uppercase character').replace('%3', config.minimum_lowercase > 1 ? config.minimum_lowercase + ' lowercase characters' : 'one lowercase character');
        }
        if (key === 'password_not_same_as_username') {
          validateMassage = _self.isCheckout ? $.mage.__('not be your username') : $.mage.__('new password cannot be same as the current password');
        }
        if (key === 'maximum_consecutive_characters') {
          validateMassage = $.mage.__('not contain %1 or more consecutive characters (e.g. 123, abc)').replace('%1', config.maximum_consecutive_characters + 1);
        }
        if (key === 'maximum_consecutive_characters_keyboard') {
          validateMassage = $.mage.__('not contain %1 or more consecutive keyboard characters (E.g. qwe, rew, QWE, ASD, asd)').replace('%1', config.maximum_consecutive_characters_keyboard + 1);
        }
        _self.validationMessagesCollection[key] = validateMassage;
      });
    },
    validationHints: function () {
      var _window$checkoutConfi;
      let passwordSelector = $(this.passwordSelector).val(),
        confirmPasswordSelector = $(this.confirmPasswordSelector).val(),
        customerEmailSelector = $(this.customerEmailSelector).val(),
        config = {},
        passwordHintBlock = [],
        _self = this;
      if (this.invalidOnSubmit()) {
        if ($(this.passwordSelector).valid()) {
          this.source.set('params.valid', 'password');
          this.invalidOnSubmit(false);
        }
      }
      this.value(passwordSelector);
      this.requiredError(false);
      this.passwordConfirmRequiredError(false);
      if (((_window$checkoutConfi = window.checkoutConfig) === null || _window$checkoutConfi === void 0 ? void 0 : _window$checkoutConfi.custom_password_validation) !== undefined) {
        config = window.checkoutConfig.custom_password_validation;
      } else {
        config = {
          "maximum_password_length": 15,
          "minimum_password_length": 8,
          "minimum_lowercase": 1,
          "minimum_uppercase": 1,
          "minimum_digits": 1,
          "password_not_same_as_username": true,
          "maximum_consecutive_characters": 2,
          "maximum_consecutive_characters_keyboard": 2
        };
      }
      this.collectValidationMessage(config);
      this.passwordHints(this._updatePasswordHintsValues(config));
      this.validationState = [];
      if (!validatePasswordFunc.passwordLength(passwordSelector, config.maximum_password_length, config.minimum_password_length)) {
        this.collectValidationState('minimum_password_length', 'maximum_password_length');
      }
      if (!validatePasswordFunc.symbolsCheck(passwordSelector, config.minimum_lowercase, config.minimum_uppercase, config.minimum_digits)) {
        this.collectValidationState('minimum_lowercase', 'minimum_uppercase');
      }
      if (!validatePasswordFunc.notUsername(passwordSelector, customerEmailSelector)) {
        this.collectValidationState('password_not_same_as_username');
      }
      if (validatePasswordFunc.consecutiveChars(passwordSelector, config.maximum_consecutive_characters)) {
        this.collectValidationState('maximum_consecutive_characters');
      }
      if (validatePasswordFunc.consecutiveKeyboardChars(passwordSelector, config.maximum_consecutive_characters)) {
        this.collectValidationState('maximum_consecutive_characters_keyboard');
      }
      this.updatePasswordHintsState();
    },
    collectValidationState: function (validation1) {
      let validation2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      let validation3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      if (validation3 !== null) {
        this.validationState[validation3] = true;
      }
      if (validation2 !== null) {
        this.validationState[validation2] = true;
      }
      if (validation1 !== null) {
        this.validationState[validation1] = true;
      }
    },
    updatePasswordHintsState: function () {
      let _self = this,
        oldHintState = _self.passwordHints();
      _self.passwordHints([]);
      $.each(oldHintState, function (key, value) {
        if (typeof _self.validationState[value.key] !== "undefined") {
          value.valid = true;
        } else {
          value.valid = false;
        }
        if (value.key === 'maximum_consecutive_characters' || value.key === 'maximum_consecutive_characters_keyboard') {
          if (typeof _self.validationState[value.key] === "undefined") {
            value.valid = true;
          } else {
            value.valid = false;
          }
        }
      });
      _self.passwordHints(oldHintState);
    },
    validateRules: function () {
      let _self = this,
        result = true;
      $.each(_self.validationState, function (value) {
        if (!value) {
          result = false;
        }
      });
      return result;
    },
    validateSubmit: function () {
      this.source.set('about.account.password', $(this.passwordSelector).val());
      this.value($(this.passwordSelector).val());
      this.validationHints();
      if (!$(this.passwordSelector).val()) {
        this.source.set('params.invalid', 'password');
        this.requiredError(true);
        return false;
      } else if (!$(this.confirmPasswordSelector).val()) {
        this.source.set('params.invalid', 'password');
        this.passwordConfirmRequiredError(true);
        return false;
      } else if ($(this.passwordSelector).val() !== $(this.confirmPasswordSelector).val()) {
        this.source.set('params.invalid', 'password');
        this.confirmError(true);
        return false;
      }
      if (!$(this.passwordSelector).valid()) {
        this.source.set('params.invalid', 'password');
        this.invalidOnSubmit(true);
        return false;
      } else {
        this.invalidOnSubmit(false);
      }
      return true;
    },
    validateConfirm: function () {
      if ($(this.passwordSelector).val() !== $(this.confirmPasswordSelector).val()) {
        this.confirmError(true);
        this.confirmMatch(false);
        return false;
      } else if ($(this.passwordSelector).val() !== "" && $(this.confirmPasswordSelector).val() !== "") {
        this.confirmMatch(true);
      } else {
        this.confirmMatch(false);
      }
      this.confirmError(false);
      return true;
    },
    showHidePassword: function () {
      if ($(this.passwordSelector).attr('type') === 'password') {
        $(this.passwordSelector).attr('type', 'text');
        $(this.confirmPasswordSelector).removeClass('masked-text');
        $(this.togglePasswordSelector).addClass("show").text($t('Hide'));
      } else {
        $(this.passwordSelector).attr('type', 'password');
        $(this.confirmPasswordSelector).addClass('masked-text');
        $(this.togglePasswordSelector).removeClass("show").text($t('Show'));
      }
    }
  });
});

